import { styled } from '@linaria/react';

export const StudienberatungBlockWrapper = styled.div`
	width: 100%;
	display: block;
`;

export const Content = styled.div`
	text-align: center;
`;

export const Icon = styled.div`
	width: 100px;
	bottom: 0;
	left: 0;
	transform: translate( -5%, 5% );
	aspect-ratio: 1/1;
	position: absolute;

	svg.scribble {
		--icon-base: var( --bg-color );

		width: 100%;
		height: 100%;
	}

	.dhsv-svg {
		--icon-base: var( --text-color );
		--icon-accent: var( --accent-color );

		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate( -50%, -50% );
		font-size: 3rem;
	}
`;

export const ContentList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	h3,
	p {
		margin-bottom: 0;
	}

	.stud-text {
		margin-top: 15px;
		margin-bottom: 10px;

		@media screen and ( max-width: 768px ) {
			margin: 10px 0;
		}
	}
`;

export const LinkItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	.dhsv-svg {
		&[type='ion'] {
			path {
				fill: ${ ( props ) =>
					props.iconColor ? props.iconColor : 'var(--text-color)' };
			}
		}
	}
`;

export const LinkItem = styled.a`
	width: 100%;
	font-size: var( --font-size-subline );
	display: flex;
	align-items: center;
	gap: var( --size-md );
	margin-top: 15px;

	.dhsv-svg {
		font-size: inherit;
	}

	@media screen and ( max-width: 768px ) {
		margin-top: 15px;
	}
`;

export const ImageWrapper = styled.div`
	width: 100%;
	aspect-ratio: 1/1;
	position: relative;

	img {
		width: 100%;
		height: 100%;
		border-radius: 100%;
		object-fit: cover;
	}

	@media screen and ( max-width: 768px ) {
		max-width: 500px;
		margin: 0 auto 30px;
	}

	@media screen and ( max-width: 500px ) {
		max-width: 235px;
	}
`;
